import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { makeStyles } from '@material-ui/core/styles';

import { useLocation } from 'react-router-dom'
import {
  EmailShareButton,
  FacebookShareButton,
  InstapaperShareButton,
  LineShareButton,
  LinkedinShareButton,
  LivejournalShareButton,
  MailruShareButton,
  OKShareButton,
  PinterestShareButton,
  PocketShareButton,
  RedditShareButton,
  TelegramShareButton,
  TumblrShareButton,
  TwitterShareButton,
  ViberShareButton,
  VKShareButton,
  WhatsappShareButton,
  WorkplaceShareButton,
} from "react-share";

import {
  EmailIcon,
  FacebookIcon,
  InstapaperIcon,
  LineIcon,
  LinkedinIcon,
  LivejournalIcon,
  MailruIcon,
  OKIcon,
  PinterestIcon,
  PocketIcon,
  RedditIcon,
  TelegramIcon,
  TumblrIcon,
  TwitterIcon,
  ViberIcon,
  VKIcon,
  WeiboIcon,
  WhatsappIcon,
  WorkplaceIcon,
} from "react-share";

import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';

import IconButton from '@material-ui/core/IconButton';

import ShareIcon from '@material-ui/icons/Share';

import Tooltip from '@material-ui/core/Tooltip';

const useStyles = makeStyles(theme => ({
   sharebutton: {
    display: "flex",
    flexDirection: "row"
   }
}))

const StyledMenu = withStyles({
  paper: {
    border: '1px solid #d3d4d5',
  },
})((props) => (
  <Menu
    elevation={0}
    getContentAnchorEl={null}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'center',
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'center',
    }}
    {...props}
  />
));

const StyledMenuItem = withStyles((theme) => ({
  root: {
    '&:focus': {
      backgroundColor: theme.palette.primary.main,
      '& .MuiListItemIcon-root, & .MuiListItemText-primary': {
        color: theme.palette.common.white,
      },
    },
  },
}))(MenuItem);

 const  routeLinks =   {
            "/": "Home",
           "/deepdive": "Deep Dive",
           "/helpfullinks": " Helpful Links",
           "/essentials" : "Essentials",
           "/faq": "FAQ",
          }

export default function Share(props) {
  
  const locs = useLocation();
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [location, setLocation] = React.useState("")
   const [headerTitle, setHeaderTitle] = React.useState("Home")

           
React.useEffect(() => {
     const locate = window.location.href;
   setLocation(locate)
  
    let str = "";
    if(locs.pathname.startsWith('/country/')){
      str = locs.pathname.substring(9)
    setHeaderTitle(str)
  
  }else if(locs.pathname.startsWith('/country')){
      setHeaderTitle("All Countries") 
      
  }else{
     str = locs.pathname;
    setHeaderTitle(routeLinks[str]);
    
  }
  }, []);

React.useEffect(() => {
     const locate = window.location.href;
   setLocation(locate)
  
    let str = "";
    if(locs.pathname.startsWith('/country/')){
      str = locs.pathname.substring(9)
    setHeaderTitle(str)
  
  }else if(locs.pathname.startsWith('/country')){
      setHeaderTitle("All Countries") 
      
  }else{
     str = locs.pathname;
    setHeaderTitle(routeLinks[str]);
    
  }
  }, [locs]);





  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div>
      
      <Tooltip title="Share">
                <IconButton 
                   aria-controls="customized-menu"
                   aria-haspopup="true" 
                   onClick={handleClick} 
                   color="inherit">

                  <ShareIcon />
                </IconButton>
              </Tooltip>

      <Menu
        id="simple-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
      
        
      

        <MenuItem>
          
           <FacebookShareButton 
                    url="https://databode.web.app"
                    quote="covid19 updates for all countries"
                    hashtag="#covid19"
                    className={classes.sharebutton}
                    
            >
            <ListItemIcon>
            <FacebookIcon size={32} round={true} />
            </ListItemIcon>
            <ListItemText primary="Facebook" />
            </FacebookShareButton>
          
          
        </MenuItem>


        <MenuItem>       
           <TwitterShareButton
                    url="https://databode.web.app" 
                    title="Covid19 live updates for all countries"                        
                    className={classes.sharebutton}
                   
           >
              <ListItemIcon>
                  <TwitterIcon  size={32} round={true}/>
              </ListItemIcon>

               <ListItemText primary="Twitter" />
            </TwitterShareButton>
          
         
        </MenuItem>


        <MenuItem>
          
           <WhatsappShareButton
                    url="https://databode.web.app"
                    title="Covid19 live updates for all countries"
                    separator=" "
                    className={classes.sharebutton}
           >
                <ListItemIcon>
                    <WhatsappIcon  size={32} round={true}/>
                </ListItemIcon>

                 <ListItemText primary="Whatsapp" />
            </WhatsappShareButton>
          
         
        </MenuItem>


       <MenuItem>
         
           <LinkedinShareButton 
                 url="https://databode.web.app"
                 title="Covid19 Live Updates"
                summary="Covid 19 statistics for all countries"
                className={classes.sharebutton}
               
           >
                 <ListItemIcon>
                    <LinkedinIcon size={32} round={true}/>
                  </ListItemIcon>

                  <ListItemText primary="Linkedin" />
            </LinkedinShareButton>
          
          
        </MenuItem>


 <MenuItem>
          
           <TelegramShareButton
                    url="https://databode.web.app"
                    title="Covid19 live updates for all countries"
                    className={classes.sharebutton}
            >
                 <ListItemIcon>
                    <TelegramIcon  size={32} round={true}/>
                 </ListItemIcon>
                  <ListItemText primary="Telegram" />
            </TelegramShareButton>
          
         
        </MenuItem>


 <MenuItem>
          
           <RedditShareButton  
                    url="https://databode.web.app"
                    title="Covid19 live updates for all countries"
                    className={classes.sharebutton}
           >
             <ListItemIcon>
            <RedditIcon  size={32} round={true}/>
              </ListItemIcon>
              <ListItemText primary="Reddit" />
            </RedditShareButton>
          
          
        </MenuItem>

 <MenuItem>
          
           <PinterestShareButton 
                  url="https://databode.web.app"
                    media="https://firebasestorage.googleapis.com/v0/b/ebencodes.appspot.com/o/databode_logo.png?alt=media&token=e43d9b88-dbad-4064-95c4-eacfaaf0269e"
                    description="Covid19 live updates for all countries"
                    className={classes.sharebutton}
           >
               <ListItemIcon>
                   <PinterestIcon  size={32} round={true}/>
                </ListItemIcon>
                <ListItemText primary="Pinterest" />
            </PinterestShareButton>
         
          
        </MenuItem>

    </Menu>

    </div>
  );
}